import React from 'react';
import { View, Text } from 'react-native';
import { useChatStyles } from './chatStyles';
import { formatDate } from './chatUtils';

interface DateSeparatorProps {
  /** 
   * Either an already-formatted date string (from groupMessagesByDate) 
   * or a raw Date/ISO string that needs formatting 
   */
  date: Date | string;
}

/**
 * Displays a centered date label to separate messages by day.
 * If the date is already a formatted string (e.g., "Dec 20, 2025"), it displays it directly.
 * If the date is a Date object or ISO string, it formats it first.
 */
export const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const chatStyles = useChatStyles();
  // Check if the date is already a formatted string (not an ISO date or Date object)
  // ISO dates contain 'T' or are Date objects
  const isFormattedString = typeof date === 'string' && !date.includes('T') && !date.includes('-');
  const displayDate = isFormattedString ? date : formatDate(date);
  
  return (
    <View style={chatStyles.dateSeparator}>
      <Text style={chatStyles.dateSeparatorText}>{displayDate}</Text>
    </View>
  );
};

